export const randomSeed = 999999;

export const articleDescriptionMaxLength = 20;
export const weightStoragePrecision = 21;
export const weightDecimalPlaces = 5;
export const materialWeightDecimalPlaces = 12;
export const garpWeightDecimalPlaces = 4;
export const garpMinimumPositiveWeight = 0.0001;
